import { FunctionBrick, registerBrick } from 'olympe'

export default class GetCryptoNames extends FunctionBrick {
    /**
     * Executed every time an input (latestListing) gets updated.
     * Note that this method will _not_ be executed if an input value is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {string} latestListing
     * @param {function(string)} setName
     */
    onUpdate(context, [latestListing], [setName]) {
        const latestListingParsed = JSON.parse(latestListing)

        const result = []

        for (let cryptoCurrency of latestListingParsed.data) {
            result.push(cryptoCurrency.name)
        }

        setName(JSON.stringify(result))
    }
}

registerBrick('017a86038f71d1077dc3', GetCryptoNames)
